import React from 'react';

// Components
import RiskProfileTargets from './components/RiskProfileTargets';
import StackedBar from '@/views/components/charts/StackedBar';

// Types
import Locale from '@/types/locale';
import RiskProfileItem from '@/types/risk-profile-item';
import { Profile as PartialOmniRiskProfileConfig } from '@/types/risk-profiles/omni/full-omni-risk-profile';
import { RiskProfileConfigRequirements } from '@/types/risk-profiles/risk-profiles';
import { StackBarData } from './types/stack-bar-data';

// Utils
import { FormattedMessage } from '@/utils/i18n';

interface Props {
  data: {
    riskProfile: PartialOmniRiskProfileConfig | RiskProfileItem;
    stackBarData: StackBarData[];
    requirements?: RiskProfileConfigRequirements[];
  };
  i18nBasePath: string;
  locale: Locale;
}

const RiskProfileRules: React.FC<Props> = ({ data, i18nBasePath, locale }) => {
  const { riskProfile, stackBarData, requirements } = data;
  const { rules } = riskProfile;
  return (
    <div className="profile-rules">
      <div className={`profile-rule-values ${rules.length > 2 ? 'summaryView' : ''}`}>
        <div className="profile-rules-header">
          <FormattedMessage id={`${i18nBasePath}.Requirements`} />
        </div>
        <div className="profile-rule-targets">
          <RiskProfileTargets requirements={requirements} rules={rules} locale={locale} />
        </div>
        <div className="profile-stacked-bar">
          {stackBarData.map((targetData, i) => (
            <StackedBar key={i} data={targetData} showLabels />
          ))}
        </div>
      </div>
    </div>
  );
};

export default RiskProfileRules;
